import { render, staticRenderFns } from "./HistoryItemTypeCourierComment.vue?vue&type=template&id=007f9053&scoped=true&"
import script from "./HistoryItemTypeCourierComment.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeCourierComment.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeCourierComment.vue?vue&type=style&index=0&id=007f9053&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f9053",
  null
  
)

export default component.exports